import { Component, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { ButtonTypeEnum } from '../button-v2';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "./dialog-v2.service";
import * as i2 from "@ngx-translate/core";
import * as i3 from "@angular/common";
import * as i4 from "primeng/api";
import * as i5 from "primeng/confirmdialog";
import * as i6 from "../icon-v2/icon.component";
import * as i7 from "../button-v2/button.component";
const _c0 = ["dialog"];
function DialogV2Component_ng_template_3_geaui_icon_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 6);
    i0.ɵɵlistener("click", function DialogV2Component_ng_template_3_geaui_icon_v2_3_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNoClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("clickable", true)("color", "blue")("file", ctx_r1.closeIcon);
  }
}
function DialogV2Component_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DialogV2Component_ng_template_3_geaui_icon_v2_3_Template, 1, 3, "geaui-icon-v2", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r1.title));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.closable);
  }
}
function DialogV2Component_ng_template_4_div_0_geaui_button_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 10);
    i0.ɵɵlistener("click", function DialogV2Component_ng_template_4_div_0_geaui_button_v2_1_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onNoClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("type", ctx_r1.buttonTypeNo);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r1.no), " ");
  }
}
function DialogV2Component_ng_template_4_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DialogV2Component_ng_template_4_div_0_geaui_button_v2_1_Template, 3, 4, "geaui-button-v2", 8);
    i0.ɵɵelementStart(2, "geaui-button-v2", 9);
    i0.ɵɵlistener("click", function DialogV2Component_ng_template_4_div_0_Template_geaui_button_v2_click_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onYesClick());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showRejectButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.buttonTypeYes)("sending", ctx_r1.loading);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, ctx_r1.yes), " ");
  }
}
function DialogV2Component_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DialogV2Component_ng_template_4_div_0_Template, 5, 6, "div", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.hideButtons);
  }
}
export class DialogV2Component {
  dialogV2Service;
  translateService;
  destroyed;
  no = '';
  yes = '';
  hideButtons = false;
  message = '';
  title = '';
  closable = true;
  confirmCallback;
  rejectCallback;
  visible = false;
  showRejectButton = false;
  buttonTypeNo = 'secondary';
  buttonTypeYes = 'primary';
  dialog;
  loading = false;
  closeIcon = '16px_close';
  constructor(dialogV2Service, translateService, destroyed) {
    this.dialogV2Service = dialogV2Service;
    this.translateService = translateService;
    this.destroyed = destroyed;
  }
  ngOnInit() {
    if (this.message) this.dialogV2Service.message = this.translateService.instant(this.message);
    this.dialogV2Service.dialogData.pipe(takeUntilDestroyed(this.destroyed)).subscribe(data => {
      this.title = data.title ?? '';
      this.initButtons(data);
      this.confirmCallback = data.confirmCallback;
      this.rejectCallback = data.rejectCallback;
    });
    if (this.visible) this.dialogV2Service.open(this);
  }
  initButtons(data) {
    const {
      no,
      yes,
      hideButtons,
      closable,
      showRejectButton,
      buttonTypeNo,
      buttonTypeYes
    } = data;
    this.closable = closable ?? true;
    this.hideButtons = !!hideButtons;
    this.showRejectButton = showRejectButton ?? true;
    this.yes = yes ?? '';
    this.no = no ?? '';
    this.buttonTypeNo = buttonTypeNo ?? 'secondary';
    this.buttonTypeYes = buttonTypeYes ?? 'primary';
  }
  onNoClick() {
    if (!this.rejectCallback) {
      this.dialog.reject();
      return;
    }
    const result = this.rejectCallback();
    if (!(result instanceof Observable)) {
      this.dialog.reject();
      return;
    }
    this.loading = true;
    result.subscribe({
      next: () => {
        this.dialog.reject();
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }
  onYesClick() {
    if (!this.confirmCallback) {
      this.dialog.accept();
      return;
    }
    const result = this.confirmCallback();
    if (!(result instanceof Observable)) {
      this.dialog.accept();
      return;
    }
    this.loading = true;
    result.subscribe({
      next: () => {
        this.dialog.accept();
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }
  ButtonTypeEnum = ButtonTypeEnum;
  static ɵfac = function DialogV2Component_Factory(t) {
    return new (t || DialogV2Component)(i0.ɵɵdirectiveInject(i1.DialogV2Service), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i0.DestroyRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DialogV2Component,
    selectors: [["geaui-dialog-v2"]],
    viewQuery: function DialogV2Component_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialog = _t.first);
      }
    },
    inputs: {
      no: "no",
      yes: "yes",
      hideButtons: "hideButtons",
      message: "message",
      title: "title",
      closable: "closable",
      confirmCallback: "confirmCallback",
      rejectCallback: "rejectCallback",
      visible: "visible",
      showRejectButton: "showRejectButton",
      buttonTypeNo: "buttonTypeNo",
      buttonTypeYes: "buttonTypeYes"
    },
    decls: 5,
    vars: 5,
    consts: [["dialog", ""], [1, "dialog-container"], [3, "key", "closeOnEscape", "closable"], ["pTemplate", "header"], ["pTemplate", "footer"], ["class", "gea-dialog-icon", 3, "clickable", "color", "file", "click", 4, "ngIf"], [1, "gea-dialog-icon", 3, "click", "clickable", "color", "file"], [4, "ngIf"], ["class", "gea-dialog-btn", 3, "type", "click", 4, "ngIf"], [1, "gea-dialog-btn", 3, "click", "type", "sending"], [1, "gea-dialog-btn", 3, "click", "type"]],
    template: function DialogV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 1)(1, "p-confirmDialog", 2, 0);
        i0.ɵɵtemplate(3, DialogV2Component_ng_template_3_Template, 4, 4, "ng-template", 3)(4, DialogV2Component_ng_template_4_Template, 1, 1, "ng-template", 4);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵclassProp("no-title", ctx.title.length === 0);
        i0.ɵɵproperty("key", ctx.dialogV2Service.key)("closeOnEscape", ctx.closable)("closable", ctx.closable);
      }
    },
    dependencies: [i3.NgIf, i4.PrimeTemplate, i5.ConfirmDialog, i6.IconComponent, i7.ButtonV2Component, i2.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-dialog-v2',
      template: "<section class=\"dialog-container\">\n  <p-confirmDialog\n    #dialog\n    [key]=\"this.dialogV2Service.key\"\n    [class.no-title]=\"title.length === 0\"\n    [closeOnEscape]=\"closable\"\n    [closable]=\"closable\">\n    <ng-template pTemplate=\"header\">\n      <span>{{ title | translate }}</span>\n      <geaui-icon-v2\n        class=\"gea-dialog-icon\"\n        *ngIf=\"closable\"\n        [clickable]=\"true\"\n        [color]=\"'blue'\"\n        [file]=\"closeIcon\"\n        (click)=\"onNoClick()\"></geaui-icon-v2>\n    </ng-template>\n    <ng-template pTemplate=\"footer\">\n      <div *ngIf=\"!hideButtons\">\n        <geaui-button-v2 class=\"gea-dialog-btn\" *ngIf=\"showRejectButton\" [type]=\"buttonTypeNo\" (click)=\"onNoClick()\">\n          {{ no | translate }}\n        </geaui-button-v2>\n        <geaui-button-v2 class=\"gea-dialog-btn\" [type]=\"buttonTypeYes\" [sending]=\"loading\" (click)=\"onYesClick()\">\n          {{ yes | translate }}\n        </geaui-button-v2>\n      </div>\n    </ng-template>\n  </p-confirmDialog>\n</section>\n"
    }]
  }], () => [{
    type: i1.DialogV2Service
  }, {
    type: i2.TranslateService
  }, {
    type: i0.DestroyRef
  }], {
    no: [{
      type: Input
    }],
    yes: [{
      type: Input
    }],
    hideButtons: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    closable: [{
      type: Input
    }],
    confirmCallback: [{
      type: Input
    }],
    rejectCallback: [{
      type: Input
    }],
    visible: [{
      type: Input
    }],
    showRejectButton: [{
      type: Input
    }],
    buttonTypeNo: [{
      type: Input
    }],
    buttonTypeYes: [{
      type: Input
    }],
    dialog: [{
      type: ViewChild,
      args: ['dialog']
    }]
  });
})();
